<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';

import { useVideoCallState } from "@/stores/videoCallState";
import i18n from "@/i18n";
import { EventManager, Events } from "@events";

import VueMarquee from "@/../../../Web.Admin/admin-frontend/modules/Announcement/components/VueMarquee.vue";

const marqueeDisabled = ref(true);
const marqueeAnnouncements = ref([]);

const props = defineProps({
    rtcId: {
        type: String,
        required: true,
    }
});

const state = useVideoCallState(props.rtcId);
let eventEmitter = null;

onMounted(async () => {
    try {
        const response = await axios.post("/api/call/get-announcements", {
            rtcId: props.rtcId,
            role: state.role,
            name: state.name,
        });

        if (response?.data?.success) {
            const announcements = response?.data?.data;
            if (announcements && announcements?.length > 0) {
                for(const announcement of announcements){
                    const announcementText = announcement?.translations?.find(t => t.languageCode === i18n?.global?.locale)?.text ?? announcement?.translations?.find(t => t?.languageCode === i18n?.global?.fallbackLocale)?.text ?? undefined;
                    if(!announcementText) continue;

                    try { 
                        announcement.style = JSON.parse(announcement.style);
                    } 
                    catch (error) { 
                        console.error({ error }); 
                        announcement.style = {};
                    }

                    try { 
                        announcement.settings = JSON.parse(announcement.settings);
                    } 
                    catch (error) { 
                        console.error({ error }); 
                        announcement.settings = {};
                    }

                    marqueeAnnouncements.value.push({
                        text: "🕒 " + announcementText,
                        duration: announcement?.settings?.duration,
                        delayBeforeStart: Number(announcement?.settings?.delayBeforeStart ?? 0) * 1000,
                        delayCycleBeforeStart: Number(announcement?.settings?.delayCycleBeforeStart ?? 0) * 1000,
                        pauseOnHover: announcement?.settings?.pauseOnHover,
                        repeat: announcement?.settings?.limitCyclePerCall,
                        reverse: announcement?.settings?.reverse,
                        style: {
                            color: announcement?.style?.color,
                            backgroundColor: announcement?.style?.backgroundColor,
                            height: announcement?.style?.height,
                            fontFamily: announcement?.style?.fontFamily,
                            fontSize: announcement?.style?.fontSize,
                            fontWeight: announcement?.style?.fontWeight,
                            position: announcement?.style?.position == 'bottom' ? 'fixed' : 'static',
                            [announcement?.style?.position ?? 'top']: '0px',
                        },
                    });
                }
            }
        }
    } 
    catch (error) {
        console.error({ error });
    }

    eventEmitter = EventManager.getEventEmitter(props.rtcId);

    eventEmitter.on(Events.WebRTCConnected, async () => {
        if(marqueeAnnouncements.value.length > 0) marqueeDisabled.value = false;
    });

    // Live Announcement (Only for Agents)
    if(state.role != "agent") return;

    /* // MOCK Live Announcement
    setTimeout(() => {
        onLiveAnnouncementReceived({
            text: "LIVE LIVE LIVE This is a live mock test announcement",
            style: JSON.stringify({
                color: "#000000",
                backgroundColor: "#ffffff",
                height: "50px",
                fontFamily: "Arial",
                fontSize: "20px",
                fontWeight: "bold",
                top: '0px',
            }),
            settings: JSON.stringify({
                duration: 15000,
                pauseOnHover: true,
                reverse: false,
            })
        })
    }, 20000);
    */

    eventEmitter.on(Events.SignalingMessageReceived, async (msg) => {
        if(msg?.type != "announcement-live"){
            return;
        }

        console.log("Live Announcement Received", msg);

        onLiveAnnouncementReceived(msg);
    });
});

function onLiveAnnouncementReceived(announcement){
    if(!announcement.text) return;

    try { 
        announcement.style = JSON.parse(announcement.style);
    } 
    catch (error) { 
        console.error({ error }); 
        announcement.style = {};
    }

    try { 
        announcement.settings = JSON.parse(announcement.settings);
    } 
    catch (error) { 
        console.error({ error }); 
        announcement.settings = {};
    }

    marqueeAnnouncements.value.unshift({
        text: "⚡ " + announcement.text,
        duration: announcement?.settings?.duration,
        pauseOnHover: announcement?.settings?.pauseOnHover,
        reverse: announcement?.settings?.reverse,
        style: {
            color: announcement?.style?.color,
            backgroundColor: announcement?.style?.backgroundColor,
            height: announcement?.style?.height,
            fontFamily: announcement?.style?.fontFamily,
            fontSize: announcement?.style?.fontSize,
            fontWeight: announcement?.style?.fontWeight,
            position: announcement?.style?.position == 'bottom' ? 'fixed' : 'static',
            [announcement?.style?.position ?? 'top']: '0px',
        },
    });

    if(marqueeAnnouncements.value.length > 0){
        if(marqueeDisabled.value){
            marqueeDisabled.value = false;
        }
        else {
            marqueeDisabled.value = true;
            setTimeout(() => {
                marqueeDisabled.value = false;
            }, 500);
        }
    }
}
</script>

<template>
    <VueMarquee v-if="!marqueeDisabled" :disabled="marqueeDisabled" :texts="marqueeAnnouncements"
        @onStatusChange="(status) => { 
            if(status == 'stopped'){
                marqueeDisabled = true; 
            }
            console.log({ marqueeStatus: status }); 
        }" 
    />
</template>
  